import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    is_offline: navigator.onLine ? false : true,
  },
  mutations: {
    netOnline(state) {
      state.is_offline = false;
    },
    netOffline(state) {
      state.is_offline = true;
    },
  },
  actions: {},
  modules: {},
});
